import { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const location = [
          "Addis Ababa", "Dire Dawa", "Adama"," Bishoftu", "Bahir Dar", "Gondar", "Hawassa", "Mekelle",  "Jimma", "Harar", "Jijiga", "Semera", "Assosa", "Gambela", "Shashemene", "Dessie", "Arba Minch", "Debre Berhan", "Wolaita Sodo", "Bonga", "Asella", "Hosaena", "Nekemte", "Other"
        ];
      
const brandModelMap = {
  Toyota: ["Corolla", "Camry", "Vitz", "Platz", "Yaris", "Yaris (Vitz Variant)", "Vios / Yaris Ativ", "Crown", "Mirai", "Avalon", "Etios", "Prius", "Belta", "Carina","Starlet",
          "RAV4", "Highlander / Kluger", "Fortuner", "4Runner", "Land Cruiser", "Prado (Land Cruiser Prado)", "Land Cruiser 70 Series",
            "Land Cruiser 300 Series", "C-HR", "Corolla Cross", "Yaris Cross", "Corolla (Levin/D4-T)", "bZ4X", "Urban Cruiser", "Rush",
          "Raize", "Hilux", "Tacoma", "Tundra", "Stout", "IMV 0 / Rangga", "Sienna", "Alphard", "Vellfire", "Innova / Hycross", "Avanza",
          "Veloz", "HiAce", "ProAce", "GR Supra", "GR86", "GR Corolla", "GR Yaris", "Coaster", "Dyna", "LiteAce / TownAce","Mark II", "Mark II Blit", "Mark X", "Other"
          ],
  Lexus: ["RX", "NX", "ES", "LS", "LX",  "Other"],
  Daihatsu: ["Terios", "Taft", "Mira", "Move", "Hijet",  "Other"],
  Hino: ["500 Series", "300 Series", "Bus",  "Other"],
  Scion: ["tC", "FR-S", "xB", "iM",  "Other"],
  Suzuki: ["Dzire", "Swift", "Alto", "Vitara", "Baleno", "Ciaz", "Celerio", "Jimny", "Every", "Every Wagon", "Carry", "S-Presso", "Carry Truck", "Eeco", "FX650"],
  Hyundai: ["Accent", "Elantra", "Tucson", "Creta", "Avante", "Santa Fe", "Atos", "Azera", "Bayon", "County", "Eon", "Excel", "Entourage", "Getz", "I10", "I20", "I30", "I40", "H1", "H200", "H300", "Starex", "Stargazer", "XG30", "XG350",  "Other"],
  Honda: ["CR-V", "e:NS1", "N-One", "Accord", "Acty", "CR-X", "CR-Z", "Crossroad", "HR-V",  "Other"],
  Chevrolet: ["Captiva", "Trailblazer", "Alero", "Astro", "C-10", "Celta", "Express", "Express 2500", "Express 3500", "HHR", "Sonic", "Spark", "Tacuma", "Venture",  "Other"],
  Mercedes: ["EQE", "C180", "EQC", "C200", "M Class", "1113", "1117", "1420", "1422", "1619", "1622", "190E", "200E", "230E", "260E", "280E", "300E", "350D", "500SE",  "Other"],
  BMW: ["1 Series", "116i", "118d", "118i", "120d", "120i", "F-Series", "F650GS", "F800", "FW", "G-Series", "K-Series", "S-Series",  "Other"],
  Audi: ["Q5", "100", "200", "Q7", "Q8", "Q2", "Q3", "R8", "RS 6",  "Other"],
  Nissan: ["Patrol", "Navara", "X-Trail", "Sunny", "Qashqai", "Juke", "Advan", "Almera", "Altima", "Armada", "Elgrand", "Frontier", "Fusion", "Pick-up", "Stanza", "Primera"],
  Geely: ["Coolray", "Azkarra", "CK", "Emgrand EC7", "Emgrand EC8", "EX5", "GX2",  "Other"],
  Chery: ["Tiggo", "Tiggo 3", "Tiggo 3x", "Tiggo 4", "Tiggo 5", "E3", "E5", "Eastar", "Cowin 1", "Cowin 2", "Cowin 3",  "Other"],
  Kia: ["Picanto", "Rio", "Seltos", "Sportage", "EV5", "K5", "Stonic", "Amanti", "EV9", "K3000", "K4", "Stinger", "Towner", "Visto",  "Other"],
  Ford: ["F-150", "Ranger", "Fiesta", "E-150", "E-250", "E-350", "Everest", "Excursion", "F-250", "F-350", "F-450", "F-650", "Figo", "Granada", "Laser", "Windstar",  "Other"],
  BYD: ["E6", "Seagull", "Song Plus", "Song L", "Yuan Plus", "Yuan Up", "Qin L", "Frigate 07", "Tang", "E1", "E2", "F3", "F6", "Flyer", "Xia", "Seal DM-i", "Destroyer 05 DM-i"],
  Volkswagen: ["ID.3", "ID.4", "ID.6", "ID.Buzz", "ID.7", "Beetle", "Polo", "ID.5", "Fox", "AAC", "Amarok", "Atlas",  "Other"],
  Tesla: ["Cybertruck", "Model 3", "Model S", "Model X", "Model Y", "Roadster",  "Other"],
  Peugeot: ["5008", "2008", "1007", "104", "Boxer", "Expert", "XP", "XR",  "Other"],
  Mitsubishi: ["Attrage", "L200", "3000", "L400", "Lancer", "Dump truck",  "Other"],
  Lifan: ["520", "530", "Abay",  "Other"],
  Iveco: ["Daily", "Massif",  "Other"],
  Daewoo: ["Matiz", "Damas", "Lanos", "Nubira", "Lacetti", "Tacuma", "Rezzo", "Tico",  "Other"],
  ISUZU: ["Trooper", "VehiCross", "Amigo", "Ascender", "ELF Truck", "Tougher",  "Other"],
  Mazda: [ "CX-3", "CX-30", "CX-5", "CX-50", "CX-60", "CX-70", "CX-90","Mazda2", "Mazda3", "Mazda6", "MX-30", "MX-5", "BT-50",  "Other"],
  Subaru: ["Impreza", "Legacy", "Forester", "Outback", "Crosstrek", "BRZ", "Ascent", "Levorg", "WRX", "Solterra",  "Other"],
  Lucid: ["Air", "Gravity",  "Other"],
  Rivian: ["R1T", "R1S", "EDV",  "Other"],
  NIO: ["ET5", "ET7", "ES6", "ES7", "EC6", "EC7", "EL6", "EL7",  "Other"],
  Polestar: ["Polestar 1", "Polestar 2", "Polestar 3", "Polestar 4", "Polestar 5",  "Other"],
  Renault: ["Clio", "Megane", "Captur", "Koleos", "Scenic", "ZOE", "Duster", "Symbol", "Talisman", "Trafic", "Other"],
  Rover: ["Range Rover", "Range Rover Evoque", "Range Rover Sport", "Discovery", "Defender", "Freelander",  "Other"],
  Sany: ["Truck", "Concrete Mixer", "Pump Truck", "Trailer", "Excavator", "Crane",  "Other"],
  Saturn: ["Ion", "Vue", "Outlook", "Astra", "Sky", "Aura", "Relay",  "Other"],
  Sinotruk: ["Howo", "T5G", "T7H", "A7", "Gold Prince", "Hohan", "Dump Truck", "Mixer Truck",  "Other"],
  Skoda: ["Octavia", "Superb", "Fabia", "Kodiaq", "Kamiq", "Scala", "Karoq", "Enyaq",  "Other"],
  SsangYong: ["Rexton", "Tivoli", "Korando", "Actyon", "Kyron", "Musso", "XLV",  "Other"],
  Venturi: ["Fetish", "Volage", "Eclectic", "America",  "Other"],
  Volvo: ["XC40", "XC60", "XC90", "S60", "S90", "V60", "V90", "C40 Recharge", "EX30", "EX90",  "Other"],
  Dongfeng: ["Glory 580", "Glory 560", "Glory 330", "Glory 370", "Other"],
  Other: ["Other"]
};
const bodyTypes = ["Sedan", "Hatchback", "SUV", "Crossover", "Compact", "Coupe", "Convertible", "Wagon", "Van", "Pickup", "Truck", "Minibus", "Bus", "MPV", "Jeep", "Other"];

const colors = ["Black", "White", "Silver", "Gray", "Blue", "Red", "Green", "Brown", "Gold", "Yellow", "Orange", "Purple", "Other"];
const engineSizes = [
        "0.6 ", "0.8 ", "1.0 ", "1.1 ", "1.2", "1.3 ", "1.4 ", "1.5 ", "1.6 ", "1.7 ", "1.8 ", "1.9 ", "2.0 ", "2.2 ", "2.4 ", "2.5 ", "2.7 ", "2.8",
        "3.0 ", "3.2 ", "3.5 ", "4.0 ", "4.5 ", "5.0 ", "5.5 ", "6.0 ", "6.5 ", "7.0 ", "7.5 ", "8.0 ", "8.5 ", "9.0 ", "10.0 ", "Other" 
      ];

function PostCar() {
  const [formData, setFormData] = useState({
    title: "",
    brand: "",
    model: "",
    year: "",
    transmission: "",
    bodyType: "",
    color: "",
    condition: "",
    fuel: "",
    engineSize: "",
    description: "",
    priceType: "",
    price: "",
    currency: "",
    sellerType: "",
    name: "",
    phone: "",
    location: "",
    images: [],
  });

  const [imagePreviews, setImagePreviews] = useState([]);
  const navigate = useNavigate();
  
  // Added 
  useEffect(() => {
    const user = localStorage.getItem("user");
    if (!user) {
      // Not logged in → redirect to login
      navigate("/login");
    }
  }, [navigate]); 

  const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === "brand") {
    // reset model when brand changes
    setFormData((prev) => ({ ...prev, brand: value, model: "" }));
  } else {
    setFormData((prev) => ({ ...prev, [name]: value }));
  }
};

  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files);
    const validImages = files.filter((file) =>
      file.type === "image/jpeg" || file.type === "image/png"
    );

    if (validImages.length + formData.images.length > 6) {
      alert("❌ Maximum 6 images allowed.");
      return;
    }

    const newPreviews = validImages.map((file) => URL.createObjectURL(file));
    setImagePreviews([...imagePreviews, ...newPreviews]);
    setFormData({
      ...formData,
      images: [...formData.images, ...validImages],
    });
  };

  const removeImage = (index) => {
    const newPreviews = [...imagePreviews];
    const newImages = [...formData.images];
    newPreviews.splice(index, 1);
    newImages.splice(index, 1);
    setImagePreviews(newPreviews);
    setFormData({ ...formData, images: newImages });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const data = new FormData();
    for (let key in formData) {
      if (key === "images") {
        formData.images.forEach((img) => data.append("images", img));
      } else {
        data.append(key, formData[key]);
      }
    }
   try {
  const res = await axios.post(`${process.env.REACT_APP_API_URL}/cars`, data);
  // console.log("🚀 Backend Response:", res.data);
   // Assume response returns the new car/order ID
  // const orderId = res.data._id || res.data.orderId; // adjust based on your backend response shape
      const orderId = res.data.id
      alert("✅ Car listed successfully!");
 
      navigate(`/order/${orderId}`);
    } catch (err) {
      console.error(err);
      alert("❌ Failed to post car");
    }
  };

  return (
     <>
          <style>
      {`
        form.PostCarForm input::placeholder,
        form.PostCarForm textarea::placeholder {
          font-size: 12px;
          color: #333;
        }

        form.PostCarForm input::-webkit-input-placeholder,
        form.PostCarForm textarea::-webkit-input-placeholder {
          font-size: 12px;
          color: #333;
        }

        form.PostCarForm input:-moz-placeholder,
        form.PostCarForm textarea:-moz-placeholder {
          font-size: 12px;
          color: #333;
        }

        form.PostCarForm input::-moz-placeholder,
        form.PostCarForm textarea::-moz-placeholder {
          font-size: 12px;
          color: #333;
        }

        form.PostCarForm input:-ms-input-placeholder,
        form.PostCarForm textarea:-ms-input-placeholder {
          font-size: 12px;
          color: #333;
        }

        form.PostCarForm select {
          color: #333;
          font-size: 12px;
        }
      `}
    </style>
    
    <div className="container mt-5 mb-3" style={{ maxWidth: "700px" }}>
      <h4 className="mb-3">Post Your Car</h4>
      <form onSubmit={handleSubmit} className="card p-4 PostCarForm" encType="multipart/form-data">
    
        <div className="mb-3">
          <input type="text" name="title" placeholder="Car Title (e.g Suzuki Dzire 2020)" value={formData.title} onChange={handleChange} className="form-control" required />
        </div>
      
        <div className="mb-3">
          <div className="mb-3">
            <select name="location" value={formData.location} onChange={handleChange} className="form-control"required>
                <option value="">Select Location</option>
                {location.map((town) => (
                  <option key={town} value={town}>{town}</option>
                ))}
              </select>
            </div> 
        </div>
        
        <div className="row mb-3">
          <div className="col">
            <select name="brand" value={formData.brand} onChange={handleChange} className="form-control" required>
              <option value="">Select Brand</option>
              {Object.keys(brandModelMap).map((brand) => (
                <option key={brand} value={brand}>{brand}</option>
              ))}
            </select>
          </div>
          <div className="col">
            <select name="model" value={formData.model} onChange={handleChange} className="form-control" required>
              <option value="">Select Model</option>
              {brandModelMap[formData.brand]?.map((model) => (
                <option key={model} value={model}>{model}</option>
              ))}
            </select>
          </div>
        </div>
        
        <div className="row mb-3">
          <div className="col">
            <select name="year" value={formData.year} onChange={handleChange} className="form-control" required>
              <option value="">Select Year</option>
              {[...Array(50)].map((_, i) => {
                const year = new Date().getFullYear() - i;
                return <option key={year} value={year}>{year}</option>;
              })}
            </select>
          </div>
          <div className="col">
            <select name="transmission" value={formData.transmission} onChange={handleChange} className="form-control" required>
              <option value="">Select Transmission</option>
              <option value="Automatic">Automatic</option>
              <option value="Manual">Manual</option>
              <option value="CVT">CVT</option>
              <option value="AMT">AMT</option>
              <option value="Other">Other</option>
            </select>
          </div>
        </div>
        
        <div className="row mb-3">
          <div className="col">
            <select name="bodyType" value={formData.bodyType} onChange={handleChange} className="form-control" required>
                  <option value="">Select Body Type</option>
                  {bodyTypes.map((type) => (
                    <option key={type} value={type}>{type}</option>
                  ))}
            </select>
          </div>
          <div className="col">
            <select name="color" value={formData.color} onChange={handleChange} className="form-control">
              <option value="">Select Color</option>
              {colors.map((c) => (
                <option key={c} value={c}>{c}</option>
              ))}
            </select>
          </div> 
        </div>
        
        <div className="row mb-3">
            <div className="col">
              <select name="condition" value={formData.condition} onChange={handleChange} className="form-control" required>
              <option value="">Select Condition</option>
              <option value="New">Brand New</option>
              <option value="Foreign Used">Foreign Used</option>
              <option value="Local Used">Local Used</option>
              <option value="Rent">Car for Rent</option>
            </select>
          </div>
          <div className="col">
            <select name="fuel" value={formData.fuel} onChange={handleChange} className="form-control" required>
              <option value="">Select Fuel Type</option>
              <option value="Benzene">Benzene</option>
              <option value="Diesel">Diesel</option>
              <option value="Electric">Electric</option>
              <option value="Hybrid">Hybrid</option>
            </select>
          </div>
          <div className="col">
          <select name="engineSize" value={formData.engineSize} onChange={handleChange} className="form-control" required>
            <option value="">Select Engine Size (L)</option>
            {engineSizes.map((size) => (
            <option key={size} value={size}>{size}</option>
          ))}
          </select>
          </div>
        </div>
        
        <div className="mb-3">
          <textarea
            name="description"
            placeholder="Description"
            value={formData.description}
            onChange={(e) => {
              handleChange(e);
              e.target.style.height = "auto"; // Reset height
              e.target.style.height = e.target.scrollHeight + "px"; // Set to scroll height
            }}
            className="form-control"
            style={{ overflow: "hidden", resize: "none", minHeight: "50px" }}>
            </textarea>
        </div>
        
        <div className="row mb-3">
          <div className="col">
            <select name="priceType" value={formData.priceType} onChange={handleChange} className="form-control" required>
              <option value="">Price Type</option>
              <option value="Fixed">Fixed</option>
              <option value="Negotiable">Negotiable</option>
              <option value="PerDay">Per Day</option>
              <option value="Call">Call for Offer</option> {/* New option */}
            </select>
          </div>
          {/* <div className="col">
            <input type="number" name="price" placeholder="Price" value={formData.price} onChange={handleChange} className="form-control" required />
          </div> */}
          <div className="col">
            {formData.priceType === "Call" ? (
              <input
                type="text"
                className="form-control"
                value="Call for Offer"
                disabled
              />
            ) : (
              <input
                type="number"
                name="price"
                placeholder="Price"
                value={formData.price}
                onChange={handleChange}
                className="form-control"
                required
              />
            )}
          </div>
          
          <div className="col">
            <select name="currency" 
              value={formData.currency} 
              onChange={handleChange} 
              className="form-control"
              disabled={formData.priceType === "Call"} // Disable currency if "Call"
            >
              <option value="">currency</option>
              <option value="ETB">ETB</option>
              <option value="USD">USD</option>
              <option value="EUR">EUR</option>
              <option value="GBP">GBP</option>
              <option value="KES">KES</option>
            </select>
          </div>
        </div>
        
        <div className="mb-3">
          <select name="sellerType" value={formData.sellerType} onChange={handleChange} className="form-control" required>
            <option value="">Select Seller Type</option>
            <option value="Private">Private</option>
            <option value="Broker">Broker</option>
            <option value="Dealership">Dealership</option>
            <option value="Other">Other</option>
          </select>
        </div>
        
        <div className="row mb-3">
          <div className="col">
            <input type="text" name="name" placeholder="Your Name" value={formData.name} onChange={handleChange} className="form-control" required />
          </div>
          <div className="col">
            <input type="text" name="phone" placeholder="Phone Number" value={formData.phone} onChange={handleChange} className="form-control" required />
          </div>
        </div>
        
        <div className="mb-3">
          <h6 className="form-label text-secondary fw-semibold">Upload Images</h6>
          <input
            type="file"
            accept=".jpg,.jpeg,.png"
            multiple
            onChange={handleImageUpload}
            className="form-control"
          /> 
        
        <div className="d-flex flex-wrap gap-2 mt-2">
            {imagePreviews.map((src, index) => (
              <div key={index} style={{ position: "relative" }}>
                <img src={src} alt="preview" style={{ height: 80, borderRadius: 4 }} />
                <button
                  type="button"
                  onClick={() => removeImage(index)}
                  style={{
                    position: "absolute",
                    top: -6,
                    right: -6,
                    background: "#dc3545",
                    color: "white",
                    border: "none",
                    borderRadius: "50%",
                    width: 20,
                    height: 20,
                    fontSize: 12,
                    cursor: "pointer",
                  }}
                >
                  ✕
                </button>
              </div>
            ))}
          </div>
        </div>
        
        <button type="submit" className="btn btn-success w-100">
          Submit Car
        </button>
      </form>
    </div>
    </>
  );
}

export default PostCar;



